var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "8px",
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voucher",
    transform: "translate(-105.000000, -718.000000)",
    fill: "#A194FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,450 C116.209139,450 118,451.790861 118,454 C118,456.209139 116.209139,458 114,458 L109,458 C106.790861,458 105,456.209139 105,454 C105,451.790861 106.790861,450 109,450 L114,450 Z M112.576969,451.692757 C112.439847,451.569081 112.230615,451.569081 112.093493,451.692757 C111.946369,451.825405 111.935238,452.051291 112.068811,452.197396 L112.068811,452.197396 L113.482,453.596 L108.6244,453.5968 C108.417625,453.5968 108.25,453.764425 108.25,453.9712 C108.25,454.177975 108.417625,454.3456 108.6244,454.3456 L108.6244,454.3456 L113.527,454.345 L112.068811,455.789143 C111.928463,455.929801 111.929592,456.156808 112.071231,456.296184 C112.21287,456.435561 112.44146,456.434439 112.581809,456.293781 L112.581809,456.293781 L114.649931,454.244788 C114.715104,454.177182 114.751079,454.086828 114.749975,453.993269 L114.749975,453.993269 L114.743974,453.924007 C114.731267,453.855956 114.698811,453.792455 114.649931,453.741751 L114.649931,453.741751 Z",
    id: "ic_arrow"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic_arrow.30651411431953ee9828b89fbdc416a1.svg";
export { ForwardRef as ReactComponent };